export default __webpack_public_path__ + "static/gallery3-d31cbbc3e259b6e6b24d3451b8ea8248.jpg";